import { render, staticRenderFns } from "./Carousel3dSlider.vue?vue&type=template&id=b1d600ac&scoped=true&"
import script from "./Carousel3dSlider.vue?vue&type=script&lang=ts&"
export * from "./Carousel3dSlider.vue?vue&type=script&lang=ts&"
import style0 from "./Carousel3dSlider.vue?vue&type=style&index=0&id=b1d600ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d600ac",
  null
  
)

export default component.exports